import React from 'react'
import { NavLink } from 'react-router-dom'
import { MeterIcon } from './ui/Icons'
import { Plus, Settings } from 'lucide-react'
import { Toast } from './ui/Toast'
import { useApp } from '../context/AppContext'

export function Layout({ children }) {
  const { operation, toast, exportProgress } = useApp()

  const navLinkClass = ({ isActive }) =>
    `flex-1 flex flex-col items-center justify-center gap-1 transition-all ${isActive ? 'text-sky-700' : 'text-slate-800'}`

  return (
    <div className="min-h-screen pb-28">
      {toast && <Toast type={toast.type} message={toast.message} exiting={toast.exiting} />}

      {exportProgress && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-xl px-8 py-6 flex flex-col items-center gap-3 min-w-[200px]">
            <div className="w-8 h-8 border-[3px] border-slate-200 border-t-sky-700 rounded-full animate-spin" />
            <p className="text-sm font-medium text-slate-800">{exportProgress.step}</p>
            {exportProgress.total > 0 && (
              <p className="text-xs text-slate-500">{Math.round((exportProgress.current / exportProgress.total) * 100)}%</p>
            )}
          </div>
        </div>
      )}

      {children}

      <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200" style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}>
        <div className="flex h-16">
          <NavLink to="/meters" className={navLinkClass}>
            <MeterIcon size={24} />
            <span className="text-xs font-semibold">Meters</span>
          </NavLink>

          <NavLink to="/" className={navLinkClass}>
            <Plus size={24} strokeWidth={2} />
            <span className="text-xs font-semibold">Add Reading</span>
          </NavLink>

          <NavLink to="/settings" className={navLinkClass}>
            <Settings size={24} strokeWidth={2} />
            <span className="text-xs font-semibold">Settings</span>
          </NavLink>
        </div>
      </nav>
    </div>
  )
}
